import * as Yup from 'yup';

const EquipmentEnergyValidation = () => {
    return (
        Yup.object().shape({
            client: Yup.string()
                .nullable()
                .required(),
            area:   Yup.array(),
            system: Yup.array(),
            site:   Yup.string()
                .nullable()
                .required(),
            name: Yup.string()
                .required(),
            equipmentType: Yup.string()
                .required(),
            manufacturer:      Yup.string(),
            modelNumber:       Yup.string(),
            serialNumber:      Yup.string(),
            energyTargetValue: Yup.string()
        })
    );
};

export default EquipmentEnergyValidation;
